import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IBodyshopService } from "../../UserService";
import { IBSAdonisService } from "../../Services/IBSAdonisService";
import { JobEstimationDetail } from "../../modals/JobEstimationDetail";
import moment from "moment";
import { Mixpanel } from "../../Services/MixPanel";
import { CommonMethodService } from "../../Services/CommonMethodService";
const bellIcon = require("../../../src/assets/images/svg/bell-icon.svg").default;
const clockIcon = require("../../../src/assets/images/svg/clock.svg").default;

const AssessmentStatus = () => {
  const [estimationDetails, setEstimationDetails] = useState<JobEstimationDetail>();
  const [stepData, setStepData] = useState([
    {
      label: "Repair Assessment",
      description: "Our team is working diligently to ensure that the assessment is thorough and accurate.",
    },
    {
      label: "Book Onsite Inspection",
      description: "Following the completion of the assessment for your car repair, the next step is to schedule your repair appointment.",
    },
    {
      label: "Book Repair",
      description:
        "Schedule your repair appointment now and get back on the road with confidence Thank you for choosing Flow Autobody. We look forward to seeing you soon!",
    },
  ]);
  const params = useParams();
  const navigate = useNavigate();
  const ibsService = new IBodyshopService();
  const ibsAdonisService = new IBSAdonisService();
  useEffect(() => {
    ibsAdonisService.getJobEstimateDetailsById(params.id as string).then((res) => {
      setEstimationDetails(res);
    });
  }, []);
  const commonMethodService = new CommonMethodService();

  const navigateToHome = () => {
    Mixpanel.track("Navigate to Home", {
      estimateId: params.id,
      status: "Repair Assessment",
  });
    commonMethodService.setQueryParams(params.id as string, "home");
    navigate(`/?estimateid=${params.id}&step=home&status=Repair Assessment`, { replace: true });
  };
  return (
    <>
      <div className="assessment-status-wrapper">
        <div className="assessment-container">
          <div className="top-sec">
            <div className="date-section">
              <p className="sec-day">{moment().format("dddd")}</p>
              <p className="sec-date">{moment().format("D, MMMM YYYY")}</p>
            </div>
            <div className="bell-icon-main">
              <img src={bellIcon} className="bell-icon" alt="bell icon" />
            </div>
          </div>
          <div className="job-sec-main">
            <div className="border-div"></div>
            <div className="job-sec">
              <p>
                My Job: <span className="highlighted-info">{params.id}</span>
              </p>
            </div>
            <div className="vehicle-sec">
              <div className="vehicle">
                Vehicle:
                <br />
                <span className="highlighted-info">{estimationDetails?.vehicleDescription || "-"}</span>
              </div>
              <div className="rego">
                Rego:
                <br />
                <span className="highlighted-info">{estimationDetails?.vehicleRegistration || "-"}</span>
              </div>
            </div>
          </div>
          <div className="assessment-status-main">
            <p className="main-heading">Assessment Status</p>
            <div className="steps-main">
              <div className="steps-path">
                <div className="round-button">
                  <img src={clockIcon} className="clock-icon" alt="clock icon" />
                </div>
                <div className="disabled-step disabled-step-1"></div>
                <div className="disabled-step disabled-step-2"></div>
              </div>
              <div className="steps-content-main">
                {stepData.map((step) => {
                  return (
                    <div className="step-content">
                      <div className="step-content-label">{step.label}</div>
                      <div className="step-content-description">{step.description}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="btn-container">
            <button onClick={navigateToHome} className="outlined-button">
              Home
            </button>
            {/* <button className="button-dark">Book Repair</button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssessmentStatus;
